import { Modal } from "antd";
import { injectIntl } from "react-intl";
import { useParams } from "react-router-dom";
import usePermissionsByCompetitionName from "../../hooks/usePermissionsByCompetitionName";
import TeamList from "../Team/TeamsList";
import { getAddTeamToSeasonColumns } from "./columnsRepository";

const AddTeamToSeasonModal = ({ intl: { formatMessage }, isOpen, setIsOpen, pageRef, reloadData }) => {
  const params = useParams();
  const { seasonEntityPermissionName } = usePermissionsByCompetitionName();
  return (
    <Modal
      open={isOpen}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={() => setIsOpen(false)}
      width={800}
      title={formatMessage({
        id: "team.add",
        defaultMessage: "Add New Team to Season",
      })}
      cancelText={formatMessage({
        id: "cancel",
        defaultMessage: "Cancel",
      })}
    >
      <TeamList
        reloadData={reloadData}
        defaultPageSize={50}
        columns={getAddTeamToSeasonColumns({
          formatMessage,
          sport: params.sport,
          seasonId: params.seasonId,
          organizationId: params.organizationId,
          reloadData,
          pageRef,
          seasonEntityPermissionName,
        })}
      />
    </Modal>
  );
};

export default injectIntl(AddTeamToSeasonModal);
